<script setup>
import { computed } from 'vue';
import { LineChart } from '@chatwoot/viz';

const props = defineProps({
  collection: {
    type: Object,
    default: () => ({}),
  },
  ariaLabel: {
    type: String,
    default: 'Conversation activity',
  },
});

const chartData = computed(() => ({
  categories: props.collection.labels || [],
  series: (props.collection.datasets || []).map((dataset, index) => ({
    id: dataset.id || `series-${index}`,
    label: dataset.label,
    color: dataset.borderColor || 'rgb(var(--blue-9))',
    data: dataset.data || [],
  })),
}));
</script>

<template>
  <LineChart
    :data="chartData"
    :aria-label="ariaLabel"
    :height="280"
    :show-values="false"
  />
</template>
